module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _c('div', {
    staticClass: "wrap goods-detail-wrap flex-column"
  }, [(_vm.currentIndex >= 0) ? _c('div', {
    ref: "menuWrapper",
    staticClass: "menu-wrapper"
  }, [_c('ul', {
    ref: "menuList"
  }, _vm._l((_vm.menuData), function(item, index) {
    return _c('li', {
      staticClass: "menu-item verticalM",
      class: {
        active: _vm.currentIndex === index
      },
      on: {
        "click": function($event) {
          return _vm.selectMenu(index)
        }
      }
    }, [_c('span', {
      staticClass: "menu-text verticallM-box"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "dishesWrapper",
    staticClass: "flex-item goods-wrapper",
    attrs: {
      "id": "dishesWrapper"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "bottom-button"
  }, [_c('mu-raised-button', {
    staticClass: "small-button server",
    staticStyle: {
      "min-width": "15% !important"
    },
    attrs: {
      "label": "客服"
    },
    on: {
      "click": _vm.openCustomServer
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "small-button collect",
    staticStyle: {
      "min-width": "15% !important"
    },
    attrs: {
      "label": "收藏"
    },
    on: {
      "click": _vm.addGoodFav
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "small-button cart",
    staticStyle: {
      "min-width": "15% !important"
    },
    attrs: {
      "content": "11",
      "label": "购物车"
    },
    on: {
      "click": _vm.gotoCart
    }
  }, [(_vm.cartGoodsNum > 0) ? _c('span', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.cartGoodsNum))]) : _vm._e()]), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "big-button add-cart",
    class: {
      disabledbtn: _vm.btnDisabled
    },
    staticStyle: {
      "min-width": "27.5% !important"
    },
    attrs: {
      "label": "加入购物车",
      "primary": "",
      "disabled": _vm.btnDisabled
    },
    on: {
      "click": _vm.joinCart
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "big-button buyNow",
    class: {
      disabledbtn: _vm.btnDisabled
    },
    staticStyle: {
      "min-width": "27.5% !important"
    },
    attrs: {
      "label": "立即购买",
      "primary": "",
      "disabled": _vm.btnDisabled
    },
    on: {
      "click": _vm.buyNow
    }
  })], 1), _vm._v(" "), _c('mu-popup', {
    attrs: {
      "position": "bottom",
      "popupClass": "custom-popup-bottom flex-column",
      "open": _vm.bottomPopup
    },
    on: {
      "close": function($event) {
        _vm.bottomPopup = false
      }
    }
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "goods-detail"
  }, [_c('div', {
    staticClass: "close-button",
    on: {
      "click": function($event) {
        _vm.bottomPopup = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-img"
  }, [_c('imgs', {
    attrs: {
      "imagePath": _vm.skuImages &&
        _vm.skuImages.length &&
        _vm.skuImages[0].imagePath &&
        _vm.skuImages[0].imagePath.imagePath
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "goods-desc"
  }, [_c('p', {
    staticClass: "price"
  }, [_c('samp', [_vm._v("¥")]), _vm._v(_vm._s((_vm.goodsSkuMsg &&
      _vm.goodsSkuMsg.sku &&
      _vm.goodsSkuMsg.sku.goodsPrice) ||
    0.0) + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "desc overflowT2"
  }, [_vm._v("\n            " + _vm._s((_vm.goodsSkuMsg && _vm.goodsSkuMsg.sku && _vm.goodsSkuMsg.sku.skuName) ||
    "") + "\n          ")])])]), _vm._v(" "), _vm._l(((_vm.goodsSkuMsg && _vm.goodsSkuMsg.fields)), function(item) {
    return _c('div', {
      staticClass: "goods-label"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.fieldName))]), _vm._v(" "), _c('div', {
      staticClass: "label-list"
    }, _vm._l((item.values), function(value) {
      return _c('span', {
        staticClass: "label",
        class: {
          active: value.isChecked == 1
        },
        on: {
          "click": function($event) {
            return _vm.selectSku(item.fieldId, value.valueId)
          }
        }
      }, [_vm._v(_vm._s(value.valueName))])
    }), 0)])
  }), _vm._v(" "), _c('div', {
    staticClass: "goods-number"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("数量")]), _vm._v(" "), _c('span', {
    staticClass: "add-btn",
    on: {
      "click": function($event) {
        return _vm.changegoodsNum('reduce')
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.goodsNum),
      expression: "goodsNum"
    }],
    domProps: {
      "value": (_vm.goodsNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.goodsNum = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "reduce-btn",
    on: {
      "click": function($event) {
        return _vm.changegoodsNum('add')
      }
    }
  }), _vm._v(" "), _c('samp', [_vm._v("件")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "bottom-button"
  }, [_c('mu-raised-button', {
    staticClass: "fullButton",
    attrs: {
      "label": "确定",
      "primary": ""
    },
    on: {
      "click": _vm.submit
    }
  })], 1)]), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.showDialog,
      "title": "DIY清单",
      "dialogClass": "custom-class diy-dialog"
    },
    on: {
      "close": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "diy-list"
  }, _vm._l((_vm.selectDIYinfo), function(diyItem, index) {
    return _c('li', {
      staticClass: "ellipsis",
      class: {
        right: index % 2 != 0
      }
    }, [_c('label', [_vm._v(_vm._s(diyItem.fieldName) + "：")]), _c('span', [_vm._v(_vm._s(diyItem.valueName))])])
  }), 0), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "取消"
    },
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": _vm.submitDIY
    },
    slot: "actions"
  })], 1), _vm._v(" "), (_vm.toast.toast) ? _c('mu-toast', {
    staticClass: "custom-toast",
    attrs: {
      "message": _vm.toast.messageTip
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52f43f95","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/classify/goodsDetail.vue
// module id = 403
// module chunks = 68